import { useState } from "react";
import useFormSubmit from "@/hooks/useFormSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah8k83oh653ivfvnoag";

const subjectOptions = ["投稿咨询", "隐私与安全", "素材与格式", "合作与建议", "其他问题"];

export default function ContactForm() {
  const [message, setMessage] = useState("");
  const { status, message: feedback, submit } = useFormSubmit(
    SUBMIT_ADDR,
    "咨询已送达，编辑会在工作日内回复你。请留意你填写的邮箱，避免错过回信。",
  );

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <form id="contact-submit-form" data-readdy-form onSubmit={submit}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-foreground-900 mb-2">
              称呼 <span className="text-accent-600">*</span>
            </label>
            <input
              id="name"
              name="name"
              type="text"
              required
              maxLength={30}
              autoComplete="off"
              placeholder="怎么称呼你都可以"
              className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-colors"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-foreground-900 mb-2">
              邮箱 <span className="text-accent-600">*</span>
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              maxLength={80}
              autoComplete="email"
              placeholder="用于接收回复，建议使用临时邮箱"
              className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-colors"
            />
          </div>

          <div className="sm:col-span-2">
            <label
              htmlFor="subject_type"
              className="block text-sm font-medium text-foreground-900 mb-2"
            >
              咨询类型 <span className="text-accent-600">*</span>
            </label>
            <select
              id="subject_type"
              name="subject_type"
              required
              defaultValue=""
              className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-colors cursor-pointer"
            >
              <option value="" disabled>
                请选择你想咨询的方向
              </option>
              {subjectOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="sm:col-span-2">
            <div className="flex items-center justify-between mb-2">
              <label htmlFor="message" className="block text-sm font-medium text-foreground-900">
                咨询内容 <span className="text-accent-600">*</span>
              </label>
              <span
                className={`text-xs ${message.length > 500 ? "text-accent-700" : "text-foreground-400"}`}
              >
                {message.length} / 500
              </span>
            </div>
            <textarea
              id="message"
              name="message"
              required
              rows={5}
              maxLength={500}
              value={message}
              onChange={(event) => setMessage(event.target.value.slice(0, 500))}
              placeholder="请描述你的问题。不要在咨询中直接粘贴敏感线索的具体细节，涉及线索内容请改用投稿通道提交。"
              className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition-colors resize-none"
            />
          </div>

          <div className="form-guard-field" aria-hidden="true">
            <label htmlFor="website_alt">请勿填写此栏</label>
            <input
              id="website_alt"
              name="website_alt"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              readOnly
            />
          </div>
        </div>

        {status === "success" && (
          <p className="mt-6 flex items-start gap-2.5 rounded-md border border-primary-300 bg-primary-100 px-4 py-3 text-sm text-primary-700">
            <i className="ri-shield-check-line mt-0.5"></i>
            {feedback}
          </p>
        )}
        {status === "error" && (
          <p className="mt-6 flex items-start gap-2.5 rounded-md border border-accent-300 bg-accent-100 px-4 py-3 text-sm text-accent-800">
            <i className="ri-error-warning-line mt-0.5"></i>
            {feedback}
          </p>
        )}

        <div className="mt-7 flex flex-col sm:flex-row items-center gap-4">
          <button
            type="submit"
            disabled={status === "submitting"}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <i className={status === "submitting" ? "ri-loader-4-line animate-spin" : "ri-mail-send-line"}></i>
            {status === "submitting" ? "正在发送…" : "发送咨询"}
          </button>
          <p className="text-xs leading-relaxed text-foreground-500">
            咨询不会公开显示，也不会用于任何营销用途。
          </p>
        </div>
      </form>
    </div>
  );
}